module.exports = __webpack_public_path__ + "images/avatar-guoziwei-a3cc1d013cda625e885644ce36bd2995.png";